import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    updateUsersList: (state, action) => {
      state.list = action.payload;
    },
  },
});

export const { updateUsersList } = usersSlice.actions;
export default usersSlice.reducer;
